import { root } from './trials';

export const trials = {
  ...root,
};
